export const ANALYTICS_TRACK = 'ANALYTICS_TRACK'
